module.exports = __webpack_public_path__ + "static/media/close_table.747e71d2.svg";